import httpClient from "./httpClient";

const base = "/staff";

export function listStaff() {
  return httpClient.get(base).then((res) => res.data.data);
}

export function getStaff(id) {
  return httpClient.get(`${base}/${id}`).then((res) => res.data.data);
}

export function createStaff(payload) {
  return httpClient.post(base, payload).then((res) => res.data.data);
}

export function updateStaff(id, payload) {
  return httpClient.put(`${base}/${id}`, payload).then((res) => res.data.data);
}

export function uploadStaffPhoto(id, file) {
  const formData = new FormData();
  formData.append("file", file);
  return httpClient
    .post(`${base}/${id}/photo`, formData, { headers: { "Content-Type": "multipart/form-data" } })
    .then((res) => res.data.data);
}

export function deleteStaff(id) {
  return httpClient.delete(`${base}/${id}`).then((res) => res.data);
}
